import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/alert';
import React, { FC } from 'react';

import { usePairDetails } from '@app/hooks/pair/usePairDetails';

interface Props {
  pairAddress: string | undefined;
}

export const PoolNotifications: FC<Props> = ({ pairAddress }) => {
  const { data: pairDetails } = usePairDetails({
    id: pairAddress ? pairAddress.toLowerCase() : null
  });

  return (
    <>
      {pairDetails?.isStable && (
        <Alert
          status="info"
          display="flex"
          border="1px solid"
          borderColor="neutral.500"
          mt="16px"
          borderRadius="10px"
          py="10px"
          px="12px"
        >
          <AlertIcon w="16px" h="16px" mr="8px" color="warning.100" />
          <AlertDescription color="warning.100">
            Stable pools may appear imbalanced when providing liquidity. This is
            by design of the AMM implementation and won&apos;t affect the swap
            rate of the pool, which will tend to remain close to 1:1
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
